module.exports = __webpack_public_path__ + "img/certificate04-2.717990ad.jpg";